import { useState, useCallback, useEffect, ComponentState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GridColumn, Grid, getSelectedState } from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import { orderBy } from "@progress/kendo-data-query";
import { getTreatmentPlanAuditLog, getClientTreatmentPlan, isClientTreatmentPlanReceived, saveTreatmentPlanAuditLog, setTreatmentPlanId, getServiceAuditLogAction } from "src/redux/actions";
import { TableRowsLoader } from "src/control-components/custom-skelton";
import { SettingsService } from "src/services/settingsService";
import { renderErrors } from "src/helper/error-message-helper";
import moment from "moment";
import CustomDrawer from "src/control-components/custom-drawer/custom-drawer";
import ClientHeader from "../client/client-profile/client-header/client-header";
import ServiceHistoryVersionCompare from "./service-history-compare";
import useModelScroll from "src/cutomHooks/model-dialouge-scroll";
import TreatmentPlanPDF from "../client/client-profile/treatment-plan/treatment-plan-pdf";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

export const TreatmentPlanActions = {
   EditService: 1,
   DeleteService: 2,
   ReactivateService: 3,
   AddServiceRate: 4,
   EditServiceRate: 5,
   DeleteServiceRate: 6,
};

const ServiceHistoryAuditLog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sort, setSort] = useState<any>([]);
  const [selectedState, setSelectedState] = useState({});
  const [loading, setLoading] = useState(true);
  const [isPrintPDF, setIsPrintPDF] = useState(false);
  const [treatmentPlan, setTreatmentPlan] = useState([]);
  const clientDetail = useSelector((state: any) => state.clientDetails);
  const clinicId = useSelector((state: any) => state.loggedIn.clinicId);
  const [clinicDetails, setClinicDetails] = useState([]);
  const [staffSignData, setStaffSignData] = useState([]);
  const [clientSignData, setClientSignData] = useState([]);
  const [versionNumber, setVersionNumber] = useState(null);
  const selectedClientId = useSelector((state: any) => state.selectedClientId);
  const [showChanges, setShowChanges] = useState(false);
  const [currentVersionData, setCurrentVersionData] = useState({});
  const [previousVersionData, setPreviousVersionData] = useState({});
  const [isInActivePlan, setIsInActivePlan] = useState(false);
  const [treatmenTPlanAuditLogList, setTreatmentPlanAuditLogList] =
    useState<any>([]);

  const state: ComponentState = useSelector(states => {
    return states;
  });
  const { clientTpId ,clientActiveInactiveTP} = state['ClientReducer']

  const { serviceAuditLogData } = state['ClinicsReducer']
  const clientTpResp = useSelector(
    (state: any) => state.ClientReducer.clientTpResp
  );
  const isClientTreatmentPlanRespReceived = useSelector(
    (state: any) => state.ClientReducer.isClientTreatmentPlanRespReceived
  );
  const [prevTreatmentPlanId, setPrevTreatmentPlanId] = useState<string | null>(
    null
  );
  const [modelScroll, setScroll] = useModelScroll();


  useEffect(() => {
    dispatch(getServiceAuditLogAction({serviceId: location?.state?.serviceId}))
  }, []);

  useEffect(() => {
    if (serviceAuditLogData?.resultData?.length > 0) {
      setTreatmentPlanAuditLogList(serviceAuditLogData?.resultData);
    } else {
      setTreatmentPlanAuditLogList([]);
    }
    setLoading(false);
  }, [serviceAuditLogData]);

  const pageChange = (event: any) => {
    let skip = event.page.skip;
    let take = event.page.take;
    setPage(skip);
    setPageSize(take);
  };

  const onSelectionChange = useCallback(
    (event: any) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);
    },
    [selectedState]
  );

  const handleError = (errorMessage: any) => {
    renderErrors(errorMessage);
  };

  const openAttachment = (selectedTp: any) => {
    setVersionNumber(selectedTp?.versionNumber);
    const data = JSON.parse(selectedTp?.currentVersionData);
    const staffSign = JSON.parse(selectedTp?.staffSignData);
    const clientSign = JSON.parse(selectedTp?.clientSignData);
    setTreatmentPlan(data);
    setStaffSignData(staffSign);
    setClientSignData(clientSign);
    setIsPrintPDF(true);
  };

  function getClassName(actionId: number) {
    switch (actionId) {
      case TreatmentPlanActions.EditService:
        return "fa fa-edit fa-lg";
      case TreatmentPlanActions.AddServiceRate:
        return "fa fa-plus fa-lg";
      case TreatmentPlanActions.EditServiceRate:
        return "fa fa-edit fa-lg";
      case TreatmentPlanActions.DeleteService:
        return "fa fa-trash fa-lg";
      case TreatmentPlanActions.DeleteServiceRate:
        return "fa fa-minus-circle fa-lg";
      case TreatmentPlanActions.ReactivateService:
        return "fa fa-refresh fa-lg";
      default:
        return "";
    }
  }

  function onBack() {
    navigate(-1);
  }

  function onActionClick(action: any) {
    setPreviousVersionData(action);
    const previousVersion = action.rowNumber + 1;

    const currentVersion = treatmenTPlanAuditLogList.find(
      (item: any) => item.rowNumber === previousVersion
    );

    setCurrentVersionData(currentVersion || null);
    setShowChanges(true);
    setScroll(true);
  }

  const handleClose = () => {
    setShowChanges(false);
    setScroll(false);
  };

  return (
    <>
            <div className="upload-sign-file pt_10 treatment_upload">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    value="BACK"
                    onClick={onBack}
                    className="border-0 bg-transparent arrow-rotate p-0 m-0 f-14"
                  >
                    <i className="fa-solid fa-arrow-left mr-2"></i>
                  </button>
                  <h4 className="address-title text-grey mb-0">
                    <span className="f-24">Service History</span>
                  </h4>
                </div>
              </div>

              {loading || isPrintPDF ? (
                <TableRowsLoader rowsNum={12} />
              ) : (
                <div className="d-flex justify-content-between mb-3 flex-wrap gy-5 filterRow">
                  {treatmenTPlanAuditLogList?.length > 0 ? (
                    <div
                      className="client-accept blue_theme"
                      style={{ overflow: "auto" }}
                    >
                      <div className="address-line-content mt-3 custom-grid table-heading-auth blueThemeTable grid-table">
                        <Grid
                          data={orderBy(
                            treatmenTPlanAuditLogList?.slice(
                              page,
                              pageSize + page
                            ),
                            sort
                          )?.map((item: any) => ({
                            ...item,
                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                          }))}
                          dataItemKey={DATA_ITEM_KEY}
                          selectedField={SELECTED_FIELD}
                          skip={page}
                          take={pageSize}
                          total={treatmenTPlanAuditLogList?.length}
                          onPageChange={pageChange}
                          className="pagination-row-cus"
                          pageable={{
                            pageSizes: [10, 20, 30],
                          }}
                          sort={sort}
                          sortable={true}
                          onSortChange={(e) => {
                            setSort(e.sort);
                          }}
                          onSelectionChange={onSelectionChange}
                        >
                          <GridColumn
                            title="Version #"
                            className="cursor-default"
                            width="150px"
                            cell={(props) => {
                              let versionNumber =
                                props?.dataItem?.versionNumber;
                              let actionId = props?.dataItem?.actionId;
                              return (
                                <td className="cursor-default">
                                  {actionId !== 0
                                    ? `v${versionNumber}`
                                    : versionNumber}
                                </td>
                              );
                            }}
                          />
                          <GridColumn
                            title="Action On"
                            width="150px"
                            className="w-5 cursor-default"
                            cell={(props) => {
                              let actionId = props.dataItem.actionId;
                              let actionName = props.dataItem.actionName;
                              return (
                                <td className="cursor-default flex items-center gap-2">
                                  <i
                                    className={`${getClassName(
                                      actionId
                                    )} text-blue-500`}
                                  />
                                  <span className="ml-2">{actionName}</span>
                                </td>
                              );
                            }}
                          />

                          <GridColumn
                            field="utcDateCreated"
                            title="Edit on"
                            width="150px"
                            className="cursor-default"
                            cell={(props) => {
                              let date = props.dataItem.utcDateCreated;
                              return (
                                <td className="cursor-default">
                                  {moment.utc(date).local().format("M/D/YYYY")}{" "}
                                  at{" "}
                                  {moment.utc(date).local().format("hh:mm A")}
                                </td>
                              );
                            }}
                          />
                          <GridColumn
                            field="operatedBy"
                            title="Action by"
                            width="150px"
                            className="cursor-default"
                          />

                          <GridColumn
                            title="View Changes"
                            width="150px"
                            cell={(props) => {
                              let action = props.dataItem;
                              let versionNumber = props?.dataItem?.versionNumber;
                              let actionId = props?.dataItem?.actionId;

                              return (
                                <td style={{ height: '35px' }}>
                                  {versionNumber === "1.1" || actionId === 16 ? null : (
                                    <span
                                      onClick={() => onActionClick(action)}
                                      className="f-14 d-flex align-items-center mb-0"
                                      style={{ cursor: 'pointer' }}
                                    >
                                      <i className="fa fa-eye pr-1"></i> View
                                    </span>
                                  )}
                                </td>
                              );
                            }}
                          />


                        </Grid>
                      </div>
                    </div>
                  ) : (
                    <div className="mt-3 message-not-found col-12">
                      No History available
                    </div>
                  )}
                </div>
              )}
            </div>
      {/* {isPrintPDF && (
        <TreatmentPlanPDF
          treatmentPlan={treatmentPlan}
          isPrintPDF={isPrintPDF}
          isOnlySaveThisFile={false}
          setIsPrintPDF={setIsPrintPDF}
          onError={handleError}
          clientSignData={clientSignData}
          staffSignData={staffSignData}
          clientDetail={clientDetail}
          clinicDetails={clinicDetails}
          phoneImage={false}
          selectedGoal={[]}
          currentInsurance={[]}
          minDiagnoseName={[]}
          versionNumber={versionNumber}
        />
      )}*/}
      {showChanges && (
        <ServiceHistoryVersionCompare onClose={handleClose} treatmenTPlanAuditLogList={treatmenTPlanAuditLogList} previousOne={currentVersionData} currentOne={previousVersionData} />
      )} 
    </>
  );
};

export default ServiceHistoryAuditLog;
